// Product roadmap store. Milestones are admin-editable; edits are
// persisted to localStorage with a baseline fallback so the app always
// renders something sensible even on a fresh machine.
//
// When Supabase is wired, replace the storage layer with a `roadmap_milestones`
// table and keep the same public API.

const STORAGE_PREFIX = 'finkloz_roadmap_';
const CHANGE_EVENT = 'finkloz:roadmap-changed';

const MILESTONE_STATUSES = ['completed', 'in_progress', 'upcoming', 'future'];
export { MILESTONE_STATUSES };

export const BASELINE_MILESTONES = [
  { id: 'ms-1', label: 'First-in-Human Study (Southern site)', period: 'Q1 2026', status: 'in_progress' },
  { id: 'ms-2', label: 'Design Freeze & Manufacturing',  period: 'Q2 2026', status: 'upcoming' },
  { id: 'ms-3', label: 'Pre-Clinical Safety Studies',    period: 'Q2-Q3 2026', status: 'upcoming' },
  { id: 'ms-4', label: 'Regulatory Submissions (FDA & HC)', period: 'Q3-Q4 2026', status: 'upcoming' },
  { id: 'ms-5', label: 'CAN/USA Feasibility Study',      period: 'Q4 2026', status: 'upcoming' },
  { id: 'ms-6', label: 'Pivotal Trial Preparation',      period: 'Q1-Q2 2027', status: 'future' },
  { id: 'ms-7', label: 'Series B Close (US$75M)',        period: 'Q3 2027', status: 'future' },
];

function key(companyId) {
  return STORAGE_PREFIX + (companyId || 'default');
}

export function getMilestones(companyId) {
  try {
    const raw = localStorage.getItem(key(companyId));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch { /* ignore */ }
  return BASELINE_MILESTONES;
}

export function saveMilestones(companyId, milestones) {
  try {
    localStorage.setItem(key(companyId), JSON.stringify(milestones));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveMilestones failed', e);
  }
}

export function resetMilestones(companyId) {
  try {
    localStorage.removeItem(key(companyId));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch { /* ignore */ }
}

export function subscribeToRoadmapChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function newMilestoneId() {
  return 'ms-' + Math.random().toString(36).slice(2, 9);
}
